import { Injectable } from '@angular/core';
import { ParentService } from "../pages/A2-utils/ParentClass/ParentService";
import { Http } from "@angular/http";
import { constant } from "../app.constants";
import { Observable } from 'rxjs/Observable';

@Injectable()
export class BackgroundCheckService extends ParentService{

  constructor(private http: Http) {
    super();
  }

  getBackgroundChecks(listType : string, showInactive : boolean, filter : string) {
    const url = `${constant.URL_GET_BACKGROUND_CHECK}/${listType}/${showInactive}?filter=${(filter)?filter:""}`;
    return this.http.get(url, this.getHeader())
      .map((resp) => resp.json());
  }

  changeApplicationStatus(data) {
    const url = `${constant.URL_GET_BACKGROUND_CHECK_APPROVE}`;
    return this.http.put(url, data, this.headerPost())
      .map((res) => res.json())
      .catch(error => Observable.throw(error.json()));
  }

  getBackgroundChecksCounts(showInactive : boolean, filter : string) {
    const url = `${constant.URL_GET_BACKGROUND_CHECK_COUNTS}/${showInactive}?filter=${(filter)?filter:""}`;
    return this.http.get(url, this.getHeader())
      .map((resp) => resp.json());
  }

  getBackgroundCheckRenewals(driverId: number) {
    const url = `${constant.URL_GET_BACKGROUND_CHECK_RENEWALS}/?driverId=${driverId}`;
    return this.http.get(url, this.getHeader())
      .map((resp) => resp.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/background-check.service.ts